/**
 * Header Component
 */

import React from 'react';
import { Layout, Button, Space, Popover, List, Badge, Avatar, Dropdown, MenuProps, message } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BellOutlined,
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useUIStore } from '../../stores';
import { api } from '../../services/api/client';
import { clearCurrentAuthSession, getCurrentAuthUser } from '../../lib/authSession';

const { Header: AntHeader } = Layout;

const visuallyHiddenStyle: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

const Header: React.FC = () => {
  const { sidebarCollapsed, toggleSidebar } = useUIStore();
  const navigate = useNavigate();
  const currentUser = getCurrentAuthUser();
  const displayName = currentUser?.username || localStorage.getItem('auth_username') || '사용자';

  const notificationContent = (
    <div style={{ width: 300 }}>
      <List
        dataSource={[]}
        renderItem={(item: any) => <List.Item>{item}</List.Item>}
        locale={{ emptyText: '새로운 알림이 없습니다' }}
      />
    </div>
  );

  const userMenu: MenuProps['items'] = [
    {
      key: 'settings',
      label: '설정',
      icon: <SettingOutlined />,
      onClick: () => navigate('/app/settings'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: '로그아웃',
      icon: <LogoutOutlined />,
      onClick: async () => {
        try {
          await api.post('/api/v1/auth/logout');
        } catch (error) {
          console.error('로그아웃 요청 실패', error);
        } finally {
          clearCurrentAuthSession();
          message.info('로그아웃되었습니다.');
          navigate('/login');
        }
      },
    },
  ];

  return (
    <AntHeader
      className="app-header"
      style={{
        padding: '0 24px',
        background: 'var(--glass-bg)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid var(--glass-border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 1,
      }}
    >
      <Button
        type="text"
        data-testid="sidebar-toggle"
        onClick={toggleSidebar}
        style={{ fontSize: '18px' }}
      >
        {sidebarCollapsed ? <MenuUnfoldOutlined aria-hidden="true" /> : <MenuFoldOutlined aria-hidden="true" />}
        <span style={visuallyHiddenStyle}>{sidebarCollapsed ? '메뉴 열기' : '메뉴 접기'}</span>
      </Button>

      <Space size="large">
        <Button type="default" onClick={() => window.location.assign('/inquiry/?source=app_header&interest=modu_startup_support')}>
          도움 요청
        </Button>
        <Popover
          content={notificationContent}
          title="알림"
          trigger="click"
          placement="bottomRight"
        >
          <Badge count={0} dot>
            <Button type="text" icon={<BellOutlined />} aria-label="알림 확인" />
          </Badge>
        </Popover>

        <Dropdown menu={{ items: userMenu }} placement="bottomRight">
          <Button type="text" aria-label="사용자 메뉴" style={{ display: 'flex', alignItems: 'center', height: 40 }}>
            <Avatar icon={<UserOutlined />} style={{ marginRight: 8, backgroundColor: '#87d068' }} />
            <span style={{ fontSize: '14px', color: 'var(--text-primary)', fontWeight: 500 }}>{displayName}</span>
          </Button>
        </Dropdown>
      </Space>
    </AntHeader>
  );
};

export default Header;
